import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

/**
 * Auth guard that ensures user is authenticated before accessing protected routes.
 * Redirects to login if not authenticated.
 */
const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;

  // If user is authenticated, allow access
  if (authenticated) {
    return true;
  }
  
  // If not authenticated, trigger Keycloak login
  const keycloak = inject(Keycloak);
  keycloak.login({
    redirectUri: window.location.origin + state.url,
  });
  
  return false;
};

export const canActivateAuth = createAuthGuard<CanActivateFn>(isAccessAllowed);
